import React, { useState } from "react";
import List from '../../../../../Templates/List';
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import moment from "moment-timezone"
import ToolBar from "../../../../../Common/Toolbar";
import ListPagination from "../../../../../Templates/List/ListPagination";
import { useGetListLastEvents } from "../../../../../../hooks/services/sKPI/useOfGAP";
import { __OBJECT_STRUCTURE_GetList } from "../../../../../../common/ObjectStructures/Trasnversal";
import CLabel from "../../../../../Common/CLabel";
import './style.css'
import { DefaultButton, Panel, PanelType, ScrollablePane, ScrollbarVisibility } from "@fluentui/react";
import PropTypes from 'prop-types';
import NoDataLayer from "../../../../../Common/NoDataLayer";

function LastEventsBox(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const {
        inputParam_GapAnalyzeId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
    } = props;

    //Parametros de componente.

    const [messageEventList, setMessageEventList] = useState(__OBJECT_STRUCTURE_GetList(10));
    const [numberOfItems, setNumberOfItems] = useState(10);
    const [messageDataLength, setMessageDataLength] = useState(0);
    useGetListLastEvents(inputParam_GapAnalyzeId, null, messageEventList.pageNumber, numberOfItems, messageEventList, setMessageEventList, setNumberOfItems, true);
   
    const onGetMoreData = () => {
        if (messageEventList.data.length !== messageDataLength) {
            setMessageEventList(prevState => ({
                ...prevState,
                data: null,
                fireUpdate: true, 
                totalRecords: messageEventList.data.length + 10,
                totalPages:  (messageEventList.data.length + 10) / messageEventList.pageSize
            }));
            setMessageDataLength(messageEventList.data.length + 10)
        }
    }

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <ListPagination
                            listLocalStoragePageSizeVariableName="lastEventMessages"
                            data={ (messageEventList !== null ? messageEventList : []) }
                            setData={ setMessageEventList } />
                    </Col>
                    <Col xl={12}>
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const onRenderHeader = () => {
        return  <Row className="ms-Panel-header headerpanel">
                    <Col role="heading" className="ms-Panel-headerText headerText">
                        { t('data-lang-lbl-lastevents') }
                    </Col>
                    <Col className='col-auto'>
                        <ToolBar items={ toolBarItems_Communication } styles={{root: {height: "30px"}}} display={ displayToolBarCommunication } />
                    </Col>
                </Row>
    }

    const toolBarItems_Communication  = [
        {
            key: 'showmore',
            text: t('data-lang-btn-showmore'),
            iconProps: { iconName: 'CPlusPlusLanguage' },
            onClick: onGetMoreData,
        },
    ];

    const displayToolBarCommunication = true;

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-lastevents') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderHeader={onRenderHeader}
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-4">
                    {
                    messageEventList.data  !== null &&
                        <List
                            manipulateLocalData={ true }
                            className="no-compact-list"
                            showHeaders={ false }
                            isHeaderVisible={ false }
                            listLocalStoragePageSizeVariableName="lastEventMessages"
                            data={ messageEventList }
                            setData={ setMessageEventList }
                            columns={ [
                            {
                                key: 'all-props-all-props',
                                name: t('data-lang-lbl-type'),
                                fieldName: 'all-props-all-props',
                                onRender:(item) => {
                                    const html = <Row>
                                                    <div className="text-end position-absolute">{ moment(item.gapEventDate).format("DD/MM/YYYY") }</div>
                                                    <Col xl={12}>
                                                        <CLabel labelText={t('data-lang-lbl-eventname')} labelValue={ item.gapEventName.indexOf('data-lang-skgapevent-type-') !== -1 ? t(item.gapEventName) : item.gapEventName} />
                                                    </Col>
                                                    { 
                                                        item.gapEventDescription &&
                                                        <Col xl={12}>
                                                                <CLabel labelText={t('data-lang-lbl-description')} labelValue={item.gapEventDescription} />
                                                        </Col>
                                                    }
                                                    <Col xl={4}>
                                                        <CLabel labelText={t('data-lang-lbl-user')} labelValue={item.gapEventUsername} />
                                                    </Col>
                                                </Row>
                                    return  html;
                                }
                            }
                        ]} />
                    } 
                    <NoDataLayer display={messageEventList.data === null} text={t('data-lang-msg-selectgap')} />                   
                </Row>
            </Panel>
              
        </div>

    );
}

///Proptypes
LastEventsBox.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number,
    inputParam_CalledFromHome: PropTypes.bool.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
};

export default LastEventsBox;

